import store from '@/store/index.js'
let dic = store.state.dic;

import { validateMoney, validatePhone } from "@/libs/elementChecker.js";

const validateUnit = (rule, value, callback) => {
    console.log(value)
    if (value) {
        if (value.length <= 15) {
            callback()
        } else {
            callback(new Error('单位名称不超过15字'));
        }
    } else {
        callback(new Error('请输入工作单位'));
    }
}
const validateJob = (rule, value, callback) => {
    if (value) {
        if (value.length <= 5) {
            callback()
        } else {
            callback(new Error('职务不超过5字'));
        }
    } else {
        callback(new Error('请输入职务'));
    }
}

export default function Configs(that) {

    const formItems = [
        {
            label: "与本人关系",
            span: 3,
            model: "relationship",
            placeholder: '请输入',

        },
        {
            label: "姓名",
            span: 2,
            model: "name",
        },
        {
            span: 3,
            label: "出生日期",
            model: "dateBirth",
            type: 'date',
        },
        // {
        //     label: "学历",
        //     span: 24,
        //     model: "degree",
        // },
        {
            label: "联系电话",
            span: 3,
            model: "contactPhone",
        },
        {
            label: "政治面貌",
            span: 2,
            model: "politicalCode",
        },
        {
            label: "工作单位",
            span: 3,
            model: "unit",
        },

        {
            label: "职务",
            span: 2,
            model: "job",
        },
        {
            span: 3,
            label: "每月经济收入",
            model: "income",
        },
        {
            label: "备注",
            span: 2,
            model: "remark",
        },
    ]




    const formRules = {
        relationship: [{
            required: true,
            message: "请选择与本人关系",
            trigger: "chagne"
        }],

        name: [{
            required: true,
            message: "请输入姓名",
            trigger: "blur"
        }],
        dateBirth: [{
            required: true,
            message: "请选择出生日期",
            trigger: "chagne"
        }],
        contactPhone: [{
            trigger: "blur",
            // message: "请输入",
            required: true,
            validator: validatePhone,
        }],
        politicalCode: [{
            required: true,
            message: "请选择政治面貌",
            trigger: "blur"
        }],
        unit: [{
            required: true,
            // message: "请输入",
            trigger: "blur",
            validator: validateUnit,
        }],
        job: [{
            required: true,
            // message: "请输入",
            trigger: "blur",
            validator: validateJob,
        }],
        income: [{
            trigger: "blur",
            // message: "请输入",
            required: true,
            validator: validateMoney,
        }],

    }

    return {
        formItems,
        formRules,
    }
}
